import { Form, Modal } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import styles from "./DismissModal.module.scss"
import { StatusReason } from "./StatusReason/StatusReason"

import type { DismissModalComponent } from "./DismissModal.types"

export const DismissModal: DismissModalComponent = (props) => {
  const { open, onOk, onCancel, status, children, okButtonProps } = props
  const { t } = useTranslation()
  const [form] = Form.useForm()

  return (
    <Modal
      destroyOnHidden
      open={open}
      okText={t("general.dismiss")}
      onOk={() => {
        onOk({ reason: form.getFieldValue("reason") })
      }}
      okButtonProps={okButtonProps}
      onCancel={onCancel}
      footer={(originNode) => <div className={styles.footer}>{originNode}</div>}
    >
      {children}
      <Form clearOnDestroy form={form} name="dismiss-issue">
        <div className={styles.reason}>
          <StatusReason status={status} t={t} />
        </div>
      </Form>
    </Modal>
  )
}
